import {
  GetSnapQuotePartInsightsRequest,
  GetSnapQuotePartInsightsResponse,
} from '@snap-types/actions/get-snap-quote-part-insights';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildTeamSnapQuoteUrl } from '@ui/store/api-builder/build-team-url';
import { injectQuery } from '@ui/store/api-builder/inject-query';

export const [getSnapQuotePartInsights, useGetSnapQuotePartInsightsQuery] =
  injectQuery<
    GetSnapQuotePartInsightsRequest,
    GetSnapQuotePartInsightsResponse
  >(
    `${QUOTE_BUILDER_SLICE_NAME}/getSnapQuotePartInsights`,
    ({ siteUuid, teamUuid, snapQuoteUuid, snapQuoteLineUuid }) => ({
      url: buildTeamSnapQuoteUrl({
        siteUuid,
        teamUuid,
        snapQuoteUuid,
        path: 'part-insights',
      }),
      params: {
        snapQuoteLineUuid,
      },
    }),
  );
